const createLoadTag = (): string => {
  const [value] = crypto.getRandomValues(new Uint32Array(1));
  return value.toString(36).padStart(7, "0");
};

/**
 * Builds an Operator entity id generator for one page load.
 *
 * Ids come from a counter, so every id the generator returns is unique for the life of the page.
 * Each generator also draws a random tag, so its ids do not match ids from an earlier load of the
 * page (still present in the chat history) or from an iframe, whose ids the iframe bridge
 * forwards into the parent page's registry unchanged. Ids are listed to the model in tool schema
 * descriptions, which is why they stay short instead of using UUIDs.
 *
 * @returns A function that returns a new id for the given prefix on every call
 */
export const createOperatorEntityIdGenerator = (): ((prefix: string) => string) => {
  const loadTag = createLoadTag();
  let lastSequence = 0;

  return (prefix: string): string => {
    lastSequence += 1;
    return `${prefix}-${loadTag}-${lastSequence}`;
  };
};
